import { z } from 'zod'

export const createStudentFormSchema = z
  .object({
    firstName: z.string().min(1, 'Поле не может быть пустым'),
    lastName: z.string().min(1, 'Поле не может быть пустым'),
    middleName: z.string(),
    iin: z
      .string()
      .min(12, 'Поле не может быть пустым')
      .max(12)
      .length(12, 'Некорректный формат. Введите 12-значный ИИН ученика.'),
    schoolId: z.string().min(1, 'Поле не может быть пустым'),
    grade: z.string().min(1, 'Поле не может быть пустым'),
    classLetter: z.string().min(1, 'Поле не может быть пустым'),
    yearFrom: z.string().min(1, 'Поле не может быть пустым'),
    yearTo: z.string().min(1, 'Поле не может быть пустым'),
    socialPayment: z.boolean(),
    wasTransferred: z.enum(['yes', 'no'], {
      message: 'Поле не может быть пустым',
    }),
    actualSchoolId: z.string(),
    actualSchoolBin: z.string(),
    transferDate: z.string(),
  })
  .superRefine((data, ctx) => {
    if (data.wasTransferred === 'yes') {
      if (!data.actualSchoolId) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['actualSchoolId'],
          message: 'Заполните поле <Название фактического места обучения>',
        })
      }

      if (!data.actualSchoolBin) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['actualSchoolBin'],
          message: 'Заполните поле <БИН Фактического места обучения>',
        })
      }

      if (!data.transferDate) {
        ctx.addIssue({
          code: z.ZodIssueCode.custom,
          path: ['transferDate'],
          message: 'Заполните поле <Дата перемещения>',
        })
      }
    }
  })
